import { render, staticRenderFns } from "./RewardPunishment.vue?vue&type=template&id=2605ddb5&scoped=true"
import script from "./RewardPunishment.vue?vue&type=script&lang=js"
export * from "./RewardPunishment.vue?vue&type=script&lang=js"
import style0 from "./RewardPunishment.vue?vue&type=style&index=0&id=2605ddb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2605ddb5",
  null
  
)

export default component.exports